import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';
import { FEE_TYPES } from '@/consts';

export default {
  async createContract(data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: 'v2/contracts/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getContractDetail(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/public-${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateContract(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${id}/`,
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data });
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async overrideOverdueFee(contractId, overridedOverdueFee) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/${contractId}:override-overdue-fee/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data: { overridedOverdueFee } });
      const fee = processSuccessResponse(res);

      return fee;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async chargeOverdueFee(contractId, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/${contractId}/fees/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data: { ...data, type: FEE_TYPES.OVERDUE } });
      const fee = processSuccessResponse(res);

      return fee;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addTransaction(contractId, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/${contractId}/transactions/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const transaction = processSuccessResponse(res);

      return transaction;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async renewContract(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/public-${id}:renew/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addContractNotes(contractId, content) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/notes/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {
        data: {
          content
        }
      });

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async sendRenewedNotification(contractId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}:send-renewed-notification/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {});

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
